import React from 'react';
import {
  Button,
  colors,
  makeStyles,
  CircularProgress,
} from '@material-ui/core';
import { Send } from '@material-ui/icons';

import useSendVerificationEmail from 'hooks/useSendVerificationEmail';

const useStyles = makeStyles({
  containedButton: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  button: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
      color: colors.grey[50],
    },
  },
});

const SendVerificationEmailButton = ({
  message = 'SEND VERIFICATION EMAIL',
  isContained = true,
}) => {
  const { sendEmail, isLoading } = useSendVerificationEmail();
  const classes = useStyles();

  return (
    <Button
      onClick={sendEmail}
      endIcon={
        isLoading ? (
          <CircularProgress
            style={{ color: 'inherit' }}
            size={24}
          ></CircularProgress>
        ) : (
          <Send></Send>
        )
      }
      className={isContained ? classes.containedButton : classes.button}
    >
      {message}
    </Button>
  );
};

export default SendVerificationEmailButton;
